import { createTheme } from '@mui/material/styles';

// Extend the theme types
declare module '@mui/material/styles' {
  interface Theme {
    interviewAcademy: {
      white: string;
      gray: {
        50: string;
        100: string;
        200: string;
        300: string;
        400: string;
        500: string;
        600: string;
        700: string;
        800: string;
        900: string;
      };
      black: string;
      primaryDark: string;
      primaryLight: string;
      secondaryDark: string;
      secondaryLight: string;
    };
  }

  // allow configuration using `createTheme`
  interface ThemeOptions {
    interviewAcademy?: {
      white?: string;
      gray?: {
        50?: string;
        100?: string;
        200?: string;
        300?: string;
        400?: string;
        500?: string;
        600?: string;
        700?: string;
        800?: string;
        900?: string;
      };
      black?: string;
      primaryDark?: string;
      primaryLight?: string;
      secondaryDark?: string;
      secondaryLight?: string;
    };
  }
}

// Layout constants
export const DRAWER_WIDTH = 216;
export const SIDEBAR_WIDTH_OPEN = 200;
export const SIDEBAR_WIDTH_CLOSED = 64;

export const theme = createTheme({
  palette: {
    primary: { main: '#49b757' },
    info: { main: '#FFFFFF' },
  },
  typography: {
    fontFamily: 'DM Sans',
  },
  interviewAcademy: {
    white: '#ffffff',
    gray: {
      50: '#F9FAFB',
      100: '#F3F4F6',
      200: '#E5E7EB',
      300: '#D1D5DB',
      400: '#9CA3AF',
      500: '#6B7280',
      600: '#4B5563',
      700: '#374151',
      800: '#1F2937',
      900: '#111827',
    },
    black: '#000000',
    primaryDark: '#0a8141',
    primaryLight: '#49b757',
    secondaryDark: '#5147b4',
    secondaryLight: '#edecf7',
  },
});
